<template>
  <nav
    class="w-full flex flex-nowrap items-center border-b border-gray-100 dark:border-slate-700/50 py-3 px-4 print:hidden sticky top-0 bg-form-box/95 dark:bg-form-box/95 backdrop-blur-sm z-[5]"
  >
    <div class="flex flex-nowrap items-center gap-4">

      <BackButton v-if="showBackButton" @click-back="handleBackClick" />

      <BaseButton v-if="isMobile" :is-icon-only="true" :is-circle="true" variant="outlines" @click="showSideBar">
        <template #left>
          <component :is="IconMenu2" size="18"></component>
        </template>
      </BaseButton>
      <h1 class="text-font-dark sm:text-[18px] lg:text-[22px] leading-[31px] text-right font-bold">
        {{ te(displayTitle) ? changeCase.capitalCase(t(displayTitle)) : displayTitle }}
      </h1>
    </div>
    <TopMenu @show-modal="showModal" :ratio="coinRatio" />
    <ModalLogout v-model:modelValue="isVisible" @logout-acc="logoutAccount" />
  </nav>
</template>

<script setup lang="ts">
//imports --------------------
import { computed, watch, ref, onBeforeMount } from 'vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { IconMenu2 } from '@tabler/icons-vue'
import { useSidebar } from '@/stores/sidebar'
import { useAuth } from '@/stores/auth'
import { useRoute, useRouter } from 'vue-router'
import BackButton from '@/components/base/BackButton.vue'
import ModalLogout from '@/components/base/ModalLogout.vue'
import { useI18n } from 'vue-i18n'
import * as changeCase from 'change-case'
import TopMenu from '@/components/main/TopMenu.vue'
import { api } from '@/plugins/axios';
// types --------------------

interface Ratio {
  ratio: number
}


// props --------------------
defineProps<{
  isMobile: boolean
}>();

// emits --------------------
const emits = defineEmits<{
  (e: 'toggleSideBar', value: boolean): void
}>();




// variables -----------------
const route = useRoute()
const router = useRouter()
const sidebar = useSidebar('main')()
const isVisible = ref(false)
const auth = useAuth()
const showBackButton = ref(false)
const { t, te } = useI18n()
const isDropdownOpen = ref(false)
const coinRatio = ref(0)
const isToggleSideBar = ref(false)
const pathes = ['/campaigns/edit', '/invoice-review', '/ticket']
const { SCORE } = CONFIG



// computed --------------------
// Page-set dynamic titles (e.g. a form's API page_title) win over the
// statically resolved menu/meta title
const displayTitle = computed(() => sidebar.dynamicTitle ?? sidebar.title)

// methods --------------------
const showModal = () => {
  isVisible.value = true
  isDropdownOpen.value = false // Close dropdown when opening modal
}

function handleBackClick() {
  if (pathes.some(path => route.path.includes(path))) {
    router.back()
  }
}

const logoutAccount = async () => {
  await auth.logout()
  await sidebar.onLogout()
}

const showSideBar = () => {
  isToggleSideBar.value = true
  emits('toggleSideBar', isToggleSideBar.value)
}


watch(
  () => route.path,
  (newPath: string) => {
    showBackButton.value =
      /^\/campaigns\/edit\/\d+$/.test(newPath) ||
      /^\/invoice-review\/\d+$/.test(newPath) ||
      /^\/ticket\/\d+$/.test(newPath)
  },
  { immediate: true }
)


onBeforeMount(() => {

  if (SCORE === '1') {
    api.get<{ data: Ratio[] }>('/admin/exchange_ratio?label=charge').then((data) => {
      coinRatio.value = data.data?.data?.[0]?.ratio ?? 0
    })
  }


})

</script>
